import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import EqualizerIcon from '@mui/icons-material/InsertChartOutlined';

import { AutoSaveProvider, useAutoSaveState, SaveButton, NameField } from '../lib/useAutoSaveState'
import calculateEnergy from '../lib/energy'
import toFixed from '../lib/toFixed'

const EnergyCalculator = () => {
  const [ velocity, setVelocity ] = useAutoSaveState('velocity', '')
  const [ weight, setWeight ] = useAutoSaveState('weight', '')
  const [ preview, setPreview ] = useAutoSaveState('preview', null)
  const [ energy, setEnergy ] = useState('')

  const calculate = () => {
    const result = calculateEnergy(
      parseFloat(weight),
      parseFloat(velocity)
    )
    setEnergy(result)
    setPreview(`${toFixed(result, 0)} ft⋅lb`)
    window.gtag('event', 'calculate-energy')
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3} justifyContent="center" >
        <Grid container justifyContent="center" xs={12} sx={{ position: 'relative' }}>
          <Typography variant="h2" component="h1" gutterBottom>
            Muzzle Energy Calculator
          </Typography>
          <SaveButton />
        </Grid>
        <NameField />
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField fullWidth label="Bullet Velocity" autoFocus value={velocity} onChange={e => setVelocity(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">fps</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Bullet Weight" value={weight} onChange={e => setWeight(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">grains</InputAdornment> }} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Button variant="contained" onClick={calculate}>Calculate</Button>
            </Grid>
          </Paper>
        </Grid>
        {!!(energy && !isNaN(energy)) && <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Typography variant="h5" gutterBottom>
                <EqualizerIcon /> Results
              </Typography>
            </Grid>
            <Divider style={{ marginBottom: '20px', marginTop: '20px' }} />
            <Box display="flex" justifyContent="space-around" mb={2}>
              <Typography variant="h5"><b>ft⋅lb:</b> {toFixed(energy, 0)}</Typography>
            </Box>
          </Paper>
        </Grid>}
      </Grid>
    </Container>
  )
}

const EnergyCalculatorWithProvider = () => (
  <AutoSaveProvider>
    <EnergyCalculator />
  </AutoSaveProvider>
)

export default EnergyCalculatorWithProvider
